<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="relative bg-gradient-to-r from-purple-300 to-blue-200">
    <div
      class="flex items-center justify-center max-w-md min-h-screen px-4 mx-auto sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl"
    >
      <div>
        <div class="text-center ">
          <h2
            class="pt-10 text-xs font-semibold tracking-wide text-gray-700 uppercase"
          >
            Vue.js Demo by Edyta Jordan
          </h2>
          <img
            class="inline-block text-center"
            alt="Vue logo"
            src="../../assets/images/logo.png"
          />
          <p
            class="mt-6 text-3xl font-extrabold tracking-tight text-gray-800 sm:text-4xl"
          >
            A nice collection of Apps done in Vue.js
          </p>
          <div class="mt-12">
            <!-- Featured Apps -->
            <div class="flex flex-wrap">
              <div
                v-for="feature in features"
                :key="feature.name"
                class="flex flex-col w-full p-4 sm:w-1/2 lg:w-1/3"
              >
                <div
                  class="flex-1 flow-root px-6 pb-8 rounded-lg shadow-sm bg-gray-50"
                >
                  <div class="-mt-6">
                    <div>
                      <span
                        class="inline-flex items-center justify-center p-3 bg-green-500 rounded-md shadow-lg"
                      >
                        <component
                          :is="feature.icon"
                          class="w-6 h-6 text-white"
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <h3
                      class="mt-8 text-lg font-medium tracking-tight text-gray-700"
                    >
                      {{ feature.name }}
                    </h3>
                    <p class="mt-5 mb-5 text-base text-gray-500">
                      {{ feature.description }}
                    </p>
                    <a
                      :href="feature.href"
                      class="px-3 py-2 mt-5 text-sm text-white bg-green-500 rounded-md shadow"
                      >{{ feature.buttonLabel }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Features -->
        <div class="mt-5 mb-5">
          <div class="px-4 py-5 mx-auto max-w-7xl sm:px-6 lg:py-5 lg:px-8">
            <div class="max-w-3xl mx-auto text-center">
              <h2 class="text-3xl font-extrabold text-gray-900">Features</h2>
              <p class="mt-4 text-gray-500">
                The above APPs feature the following technologies:
              </p>
            </div>
            <dl
              class="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8"
            >
              <div
                v-for="feature in features2"
                :key="feature.name"
                class="relative"
              >
                <dt>
                  <CheckIcon
                    class="absolute w-6 h-6 text-green-500"
                    aria-hidden="true"
                  />
                  <p class="text-lg font-medium leading-6 text-gray-900 ml-9">
                    {{ feature.name }}
                  </p>
                </dt>
                <!--                    <dd class="mt-2 text-base text-gray-500 ml-9">
                      {{ feature.description }}
                    </dd>-->
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CubeTransparentIcon,
  UserGroupIcon,
  LightBulbIcon,
  CheckIcon
} from '@heroicons/vue/outline';

const features = [
  {
    name: 'Monster Slayer Game',
    icon: CubeTransparentIcon,
    buttonLabel: 'Become a Slayer',
    href: '/monster-slayer-game',
    description: 'Game - Become a Hero by slaying an evil Monster! '
  },
  {
    name: 'Find a Coach App',
    icon: UserGroupIcon,
    buttonLabel: 'Find a Coach',
    href: '/coaches',
    description:
      'An advanced App that allows for filtering of existing coaches and messaging the selected one. Want to become a coach? Register today!'
  },
  {
    name: 'Idea Generator App',
    icon: LightBulbIcon,
    buttonLabel: 'Generate Ideas',
    href: '/idea-generator-app',
    description:
      'A project idea generator. Select the skills you want to work on and be given project idea suggestions based on those selections.'
  }
];

const features2 = [
  {
    name: 'Vue.js 3'
  },
  {
    name: 'Composition API'
  },
  {
    name: 'Hooks / Composables'
  },
  {
    name: 'SPA (Single Page Application)'
  },
  {
    name: 'Vue Router'
  },
  {
    name: 'Vuex'
  },
  {
    name: 'Oauth2 Authentication'
  },
  {
    name: 'TailwindCSS 2.0+'
  },
  {
    name: 'Tailwind UI'
  },
  {
    name: 'PurgeCSS'
  },
  {
    name: 'Axios'
  },
  {
    name: 'Mixins'
  },
  {
    name: 'Provide / Inject'
  },
  {
    name: 'Firebase Realtime Database'
  },
  {
    name: 'Vercel Hosting'
  }
];

export default {
  components: {
    CheckIcon
  },
  setup() {
    return {
      features,
      features2
    };
  }
};
</script>
